<!-- CAP-39922 New Submission History Change -->
<div class="submission-history-container" [class.collapsed]="!isPanelExpanded">
  <!-- Search Panel -->
  <div class="search-panel" [class.collapsed]="!isPanelExpanded">
    <div class="panel-icon" (click)="togglePanel()">
      <mat-icon class="chevron" [class.down]="!isPanelExpanded"
        >expand_less</mat-icon
      >
    </div>

    <div class="collapsed-search-bar" *ngIf="!isPanelExpanded">
      <span placeholder="" class="collapsed-search-input">{{
        "dimbo.i18n.submissionHistory.collapsed.changeSearch" | translate
      }}</span>
      <!-- Start: CAP-39922 DMBR-64 -->
      <span
        class="collapsed-result-count"
        *ngIf="!isVinSearch && totalResultCount > 0"
      >
        {{
          "dimbo.i18n.submissionHistory.collapsed.resultCount"
            | translate
              : {
                  count: totalResultCount,
                  startDate: filterStartDate,
                  endDate: filterEndDate
                }
        }}
      </span>
      <!-- End: CAP-39922 DMBR-64 -->
    </div>

    <div class="search-boxes" *ngIf="isPanelExpanded">
      <!-- Box 1: Filter search (Date + RRDI + Scope) -->
      <form
        [formGroup]="searchForm"
        (ngSubmit)="onFilterSearch()"
        class="search-sub-box"
      >
        <div class="form-column">
          <div class="input-group order-start-date">
            <label>{{
              "dimbo.i18n.submissionHistory.label.startDate" | translate
            }}</label>
            <mat-form-field class="input-wrapper data-field" appearance="none">
              <input
                matInput
                [matDatepicker]="startPicker"
                formControlName="startDate"
                [placeholder]="'dd/MM/yyyy'"
                [max]="maxDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="startPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="input-group order-repairer repairer-id-group">
            <label>{{
              searchForm.get("searchScope")?.value
                ? ("dimbo.i18n.submissionHistory.label.physicalSite"
                  | translate)
                : ("dimbo.i18n.submissionHistory.label.repairerId" | translate)
            }}</label>
            <input
              type="text"
              formControlName="repairerId"
              class="underline-input"
              [readonly]="!isCentralUser"
              [placeholder]="
                searchForm.get('searchScope')?.value
                  ? ('dimbo.i18n.submissionHistory.placeholder.enterPhysicalSite'
                    | translate)
                  : ('dimbo.i18n.submissionHistory.placeholder.enterRrdi'
                    | translate)
              "
            />
          </div>
        </div>

        <div class="form-column">
          <div class="input-group order-end-date">
            <label>{{
              "dimbo.i18n.submissionHistory.label.endDate" | translate
            }}</label>
            <mat-form-field class="input-wrapper data-field" appearance="none">
              <input
                matInput
                [matDatepicker]="endPicker"
                formControlName="endDate"
                [placeholder]="'dd/MM/yyyy'"
                [max]="maxDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="endPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="input-group toggle-group">
            <label>{{
              "dimbo.i18n.submissionHistory.label.searchScope" | translate
            }}</label>
            <div class="toggle-wrapper">
              <span
                class="toggle-label"
                [class.active]="!searchForm.get('searchScope')?.value"
                >RRDI</span
              >
              <label class="switch">
                <input type="checkbox" formControlName="searchScope" />
                <span class="slider round"></span>
              </label>
              <span
                class="toggle-label"
                [class.active]="searchForm.get('searchScope')?.value"
                >{{
                  "dimbo.i18n.submissionHistory.label.physicalSite" | translate
                }}</span
              >
            </div>
          </div>
        </div>

        <div class="sub-box-action">
          <button type="submit" class="btn-search">
            {{ "dimbo.i18n.submissionHistory.button.search" | translate }}
          </button>
        </div>
      </form>

      <!-- Divider -->
      <!-- <div class="box-divider"></div> -->

      <!-- Box 2: VIN search -->
      <form
        [formGroup]="searchForm"
        (ngSubmit)="onVinSearch()"
        class="search-sub-box search-sub-box--vin"
      >
        <div class="vin-input-wrapper">
          <div class="input-group vin-input-group">
            <label id="vehicle-label">{{
              "dimbo.i18n.submissionHistory.label.vehicle" | translate
            }}</label>
            <input
              type="text"
              formControlName="vehicleVin"
              class="underline-input"
              [placeholder]="
                'dimbo.i18n.submissionHistory.placeholder.enterVin' | translate
              "
              maxlength="17"
              (input)="
                $any($event.target).value = $any(
                  $event.target
                ).value.toUpperCase();
                searchForm
                  .get('vehicleVin')!
                  .setValue($any($event.target).value, { emitEvent: false })
              "
            />
          </div>
          <span
            class="vin-error"
            *ngIf="
              searchForm.get('vehicleVin')?.errors?.pattern &&
              searchForm.get('vehicleVin')?.dirty
            "
            >{{
              "dimbo.i18n.vinSearchBox.error.invalidFormat" | translate
            }}</span
          >
        </div>
        <div class="sub-box-action">
          <button type="submit" class="btn-search">
            {{ "dimbo.i18n.submissionHistory.button.search" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Results Area -->
<div class="results-area">
  <app-history
    [searchResults]="displayedResults"
    [loading]="loading"
    [errorMessage]="errorMessage"
    [isVinSearch]="isVinSearch"
    [hasSearched]="hasSearched"
    [submissionMode]="submissionMode"
    [isCentralUser]="isCentralUser"
    (vehicleInfoChange)="onVehicleInfoChange($event)"
  >
  </app-history>
</div>

<!-- Load more spinner -->
<div *ngIf="loadingMore" class="loading-more">
  <mat-spinner diameter="28"></mat-spinner>
</div>

<!-- Scroll anchor for IntersectionObserver -->
<div #scrollAnchor class="scroll-anchor"></div>

<!-- Back to Top -->
<button
  class="back-to-top"
  (click)="scrollToTop()"
  *ngIf="showBackToTop"
  [title]="'dimbo.i18n.submissionHistory.button.backToTop' | translate"
>
  <mat-icon>keyboard_arrow_up</mat-icon>
</button>
